export const smaller = '820px'
export const small = '1024px'
export const medium = '1200px'
